import { removeAuth0Prefix } from '../../users'
import type { Task } from '@paintscout/api'

/**
 * Performs a loose equality check on two objects, treating falsey values as equal
 * @example isLooselyEqual({ a: '' }, { a: null }) // true
 */
export function isLooselyEqual(first: any, second: any, ignoreKeys: string[] = []) {
  return compare(first, second, {}, ignoreKeys) && compare(second, first, {}, ignoreKeys)
}

export function compare(first: any, second: any, diff: any = {}, ignoreKeys: string[] = []) {
  for (const key in first) {
    if (ignoreKeys.includes(key)) {
      continue
    }
    if (first?.[key] !== second?.[key]) {
      if (typeof first?.[key] === 'object' && typeof second?.[key] === 'object') {
        compare(first[key] as any, second[key] as any, diff, ignoreKeys)
      } else if (!(isFalsey(first?.[key]) && isFalsey(second?.[key]))) {
        diff[key] = { first: first?.[key], second: second?.[key] }
      }
    }
  }
  return Object.keys(diff).length === 0
}

function isFalsey(value: any) {
  // If the value is an object, check if all of its keys are falsey
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).every((key) => isFalsey(value[key]))
  } else {
    return [undefined, null, false, '', '<p></p>', 0, -1, '0', '-1'].includes(value)
  }
}

/**
 * Less flaky to compare only the fields that the user can edit in TaskForm
 */
export function areTasksLooselyEqual(first: Partial<Task>, second: Partial<Task>, ignoreKeys: string[] = []): boolean {
  return isLooselyEqual(cleanTaskForComparison(first), cleanTaskForComparison(second), ignoreKeys)
}

function cleanTaskForComparison(task: Partial<Task>): Partial<Task> {
  return {
    title: task?.title,
    dealId: task?.dealId,
    owner: { id: removeAuth0Prefix(task?.owner?.id || '') },
    notes: task?.notes,
    startDateTime: task?.startDateTime
  }
}
